module.exports = __webpack_public_path__ + "img/velo-place-des-marthy.32dcca99.jpg";